import {
  MockHook,
  useABAC,
  useAlterCompanyLogo,
  LogoContext,
  useEntitlements,
  useAccounts,
} from '@jupiterone/jupiter-web-toolkit';
import { useState, useContext, ChangeEvent, FormEvent } from 'react';
import { FeatureEntitlementName } from '@jupiterone/entitlement-types';

const useCompanyLogoSettingLogic = () => {
  const { account } = useAccounts();
  const { isAdmin } = useABAC();
  const appContext = useContext(LogoContext.LogoContext);
  const {
    entitlementEnforce,
    loading: entitlementsLoading,
  } = useEntitlements();
  const hasFeatureEntitlement =
    !entitlementsLoading &&
    entitlementEnforce(FeatureEntitlementName.CUSTOM_LOGO);

  const [hasUrlChanged, setHasUrlChanged] = useState(false);
  const [imageUrlValue, setImageUrlValue] = useState(
    appContext.logoURI || account?.logo || ''
  );
  const { loading, changeAccountLogoUrl } = useAlterCompanyLogo();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!hasFeatureEntitlement || !isAdmin) {
      return;
    }
    await changeAccountLogoUrl(imageUrlValue, setHasUrlChanged);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!hasFeatureEntitlement || !isAdmin) {
      return;
    }
    if (e.target && e.target.value) {
      const hasUrlValueChanged = e.target.value !== appContext.logoURI;
      setHasUrlChanged(hasUrlValueChanged);
      setImageUrlValue(e.target.value);
    } else {
      setImageUrlValue('');
      if (appContext.logoURI) {
        setHasUrlChanged(true);
      } else {
        setHasUrlChanged(false);
      }
    }
  };

  return {
    disabled: !hasFeatureEntitlement,
    isAdmin,
    handleSubmit,
    handleChange,
    imageUrlValue,
    loading,
    hasUrlChanged,
  };
};

export type CompanyLogoSettingComponentProps = ReturnType<
  typeof useCompanyLogoSettingLogic
>;
export const MOCK_COMPANY_LOGO_SETTING_PROPS: CompanyLogoSettingComponentProps = {
  handleSubmit: MockHook.mockFunction,
  handleChange: MockHook.mockFunction,
  imageUrlValue: 'companylogo.url',
  isAdmin: true,
  disabled: false,
  loading: false,
  hasUrlChanged: false,
};
export default MockHook.useMockHook(
  useCompanyLogoSettingLogic,
  MOCK_COMPANY_LOGO_SETTING_PROPS
);
